export default __webpack_public_path__ + "static/juice-98d0ddcf6a5f66c890ca7a26646ad423.jpg";